import type React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  margin-top: ${theme.spacing.xs};
`

const StyledCheckbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.colors.primary};
`

const CheckboxLabel = styled.label`
  font-size: ${theme.typography.sm};
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;
  user-select: none;
`

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  htmlFor?: string
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, htmlFor, id, ...props }) => {
  const inputId = id || htmlFor

  return (
    <Container>
      <StyledCheckbox type="checkbox" id={inputId} {...props} />
      <CheckboxLabel htmlFor={inputId}>{label}</CheckboxLabel>
    </Container>
  )
}
